
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#A0A5BA","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.354 15.417a3.125 3.125 0 010-6.25h1.875a.208.208 0 00.209-.209V6.875a2.083 2.083 0 00-2.084-2.083H2.187A2.083 2.083 0 00.104 6.875v10.833a2.083 2.083 0 002.083 2.084h14.167a2.083 2.083 0 002.084-2.084v-2.083a.208.208 0 00-.209-.208h-1.875z"}}),_c('path',{attrs:{"d":"M18.854 10.417h-2.5a1.875 1.875 0 100 3.75h2.5a1.256 1.256 0 001.042-1.25v-1.25a1.256 1.256 0 00-1.042-1.25zM16.51.98a1.016 1.016 0 00-1.25-.737L4.533 3.131a.208.208 0 00.054.409l12.3.018a.207.207 0 00.203-.259L16.51.98z"}})])
          )
        }
      }
    